import React, { useState } from 'react';

import GhostButton from '../GhostButton';
import SetupCard from '../SetupCard';

import SessionTypeForm from './SessionTypeForm';

const regionId = (type) => `setup-wizard-session-type-${type.id}`;

/**
 * "Session types": one card per type, the starter set's still tagged
 * "Suggested". "+ Add a session type" opens a form below them, and "Edit
 * session types" opens a rename-or-delete form under every card, as
 * R.A.D.I.O.'s "Edit categories" does.
 */
export default function SessionTypeList({ types, onAdd, onUpdate, onDelete }) {
    const [editing, setEditing] = useState(false);
    const [adding, setAdding] = useState(false);

    return (
        <div className="tw-flex tw-flex-col tw-gap-y-2 tw-max-w-2xl">
            {types.length === 0 && !adding && (
                <p className="tw-text-sm tw-text-charcoal-50 tw-mb-0">{$t('Add a session type first. Every session needs one.')}</p>
            )}

            {types.map((type) => (
                <SetupCard key={type.id} heading={type.name} chip={type.suggested ? $t('Suggested') : null} expanded={editing} regionId={regionId(type)}>
                    <SessionTypeForm
                        // Remounted when the saved type changes, so the form never
                        // shows a stale name after a save elsewhere on the page.
                        key={`${type.name}-${type.is_medal}`}
                        id={regionId(type)}
                        initial={type}
                        autoFocus={false}
                        onSubmit={(body) => onUpdate(type, body)}
                        onDelete={() => onDelete(type)}
                        onCancel={() => setEditing(false)}
                    />
                </SetupCard>
            ))}

            {adding && (
                <SessionTypeForm
                    id="setup-wizard-new-session-type"
                    onSubmit={(body) => onAdd(body).then(() => setAdding(false))}
                    onCancel={() => setAdding(false)}
                />
            )}

            <div className="tw-flex tw-flex-wrap tw-gap-2.5 tw-mt-1">
                <GhostButton expanded={adding} onClick={() => setAdding((current) => !current)}>
                    {$t('+ Add a session type')}
                </GhostButton>
                {types.length > 0 && (
                    <GhostButton expanded={editing} aria-controls={types.map(regionId).join(' ')} onClick={() => setEditing((current) => !current)}>
                        {$t('Edit session types')}
                    </GhostButton>
                )}
            </div>
        </div>
    );
}
